import CustomAPILoader from './CustomAPILoader';

export default CustomAPILoader;
